import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { MEMBERSHIP_JOURNEY_QUERY } from '../components/queries/member'
import { COACH_TOOLS_API } from '../apolloClient'

const transformPersonData = (person) => {
  if (!person) return null
  
  // Map mainProgramTypeCode to match V3 API behavior for backwards compatibility
  // V3 returns 'AP' for type, which is used to route to proper dashboard for Associates + Affiliates
  let programType = person.mainProgramTypeCode === 'AF' ? 'AP' : person.mainProgramTypeCode
  
  // For terminated users, mainProgramTypeCode may be null
  // Fallback to type on termination record
  if (!programType && person.termination?.type) {
    programType = person.termination.type === 'AF' ? 'AP' : person.termination.type
  }

  const pgmProgress = person.pgmProgressStatus
  
  const mostRecentCompletedLevelKey = pgmProgress?.mostRecentCompletedLevelKey
  const mostRecentCompletedLevel = mostRecentCompletedLevelKey
    ? pgmProgress?.levels?.find(l => l.key === mostRecentCompletedLevelKey)?.levelCode
    : null
  
  return {
    ...person,
    // Override/add transformed fields for backward compatibility
    type: programType,
    class: person.classification,
    curriculumVersion: pgmProgress?.curriculumVersion,
    education: {
      currentLevel: pgmProgress?.currentLevelCode,
      mostRecentCompletedLevel: mostRecentCompletedLevel,
      levels: pgmProgress?.levels?.map(level => ({
        levelCd: level.levelCode,
        completeCd: level.status === 'complete' ? 'COMPLETE' : null,
        startDate: level.startDate,
        endDate: level.completionDate || level.expirationDate
      })) || []
    },
    pgmProgress
  }
}

export const useMembershipJourney = () => {
  const { data, loading, error, refetch } = useQuery(MEMBERSHIP_JOURNEY_QUERY, {
    context: {
      api: COACH_TOOLS_API
    },
    fetchPolicy: 'cache-and-network'
  })

  const person = useMemo(() => transformPersonData(data?.me), [data?.me])

  return {
    person,
    loading,
    error,
    refetch
  }
}
